import UpgradeList from "./components/UpgradeList.vue";
// import applicationReport from "./components/applicationReport";
import virtualView from "@/router/virtualView";
import InterviewsList from "./components/InterviewsList.vue";

export default {
  path: "upgrade",
  component: virtualView,
  children: [
    {
      path: "",
      name: "Upgrade Review",
      redirect: "application/list",
    },
    {
      path: "list/:stage?",
      name: "Upgrade List",
      component: UpgradeList,
    },
    {
      path: "open/interviews",
      name: "upgradeInterviews",
      component: InterviewsList,
    },
    {
      path: "scheduled/interviews",
      name: "scheduledUpgradeInterviews",
      component: InterviewsList,
    },
    // {
    //   path: "reports",
    //   name: "Upgrade Reports",
    //   component: applicationReport,
    // },
  ],
};
